module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.current) ? _c('div', {
    staticClass: "row",
    class: {
      'wait': _vm.deletionStarted
    },
    attrs: {
      "id": "news-detail-panel"
    }
  }, [(_vm.showConfirmModal) ? _c('confirmModal', {
    attrs: {
      "message": "Vous êtes sûr de vouloir supprimer cet article ?"
    },
    on: {
      "confirm": _vm.deletePage,
      "closeMessage": function($event) {
        _vm.showConfirmModal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showDeleteMessage) ? _c('messageModal', {
    attrs: {
      "message": "votre article a été supprimée"
    },
    on: {
      "closeMessage": _vm.goToPageList
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "detailed-news-panel"
  }, [_c('div', {
    staticClass: "detailed-news-panel-title"
  }, [_c('div', {
    staticClass: "row columns"
  }, [_c('div', {
    staticClass: "medium-5 columns"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.current.title)
    }
  }), _vm._v(" "), _c('p', [_c('span', [_c('i', {
    staticClass: "fa fa-calendar",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("le " + _vm._s(_vm._f("formatDate")(_vm.current.created)) + "\n                          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "medium-4 columns"
  }, [_c('div', {
    staticClass: "row columns"
  }, [_c('div', {
    staticClass: "medium-8 large-centered columns"
  }, [_c('img', {
    staticClass: "league-icon",
    attrs: {
      "src": _vm.current.featured_club.icon_path,
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "medium-3 columns"
  }, [_c('div', {
    staticClass: "detailed-news-actions"
  }, [(_vm.currentUser !== null) ? _c('div', [(_vm.currentUser.is_superuser) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'pageEdit',
        params: {
          id: _vm.current.id.toString()
        }
      }
    }
  }, [_c('button', {
    staticClass: "full-width"
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("Modifier")])]) : _vm._e(), _vm._v(" "), (_vm.currentUser.is_superuser) ? _c('button', {
    staticClass: "full-width alert",
    on: {
      "click": function($event) {
        _vm.showConfirmModal = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("Supprimer")]) : _vm._e()], 1) : _vm._e()])])]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "panel-content",
    domProps: {
      "innerHTML": _vm._s(_vm.current.content)
    }
  })]), _vm._v(" "), _c('commentPanel', {
    attrs: {
      "entity_type": _vm.pageContentType.id,
      "entity_id": _vm.id
    }
  })], 1) : _c('div', {
    staticClass: "row"
  }, [_c('spinner')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c860e18"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/page-detail.vue
// module id = 704
// module chunks = 0